import {
  addStaffingStatus,
  editStaffingStatus,
  addLostDroppedStatus,
  editLostDroppedStatus,
  addGeography,
  updateGeography,
} from '../../../Api/request/staffAugStatusMaster';
import { STATUS_CODES } from '../../../Api/resources/statusCodes';
import { ADD_EDIT_STAFF_AUG_STATUS, OOPS_TRY_AGAIN, AUTHENTICATION_FAILED } from '../../../Constants/strings';
import UseAxios from '../../../Api/http/http';

export const handleApiResponse = ({
  responseData,
  isEditMode,
  updateRowsWithEditedStatus,
  getStaffAugStatusData,
  snackbarOpen,
  handleCloseWithReset,
  statusCategory,
}) => {
  const { response } = responseData.data || {};
  const { status, data } = response || {};

  if (status) {
    switch (status) {
    case STATUS_CODES.BAD_REQUEST:
      snackbarOpen(data?.externalMessage, 'warning');
      break;
    case STATUS_CODES.UNAUTHORIZED:
      snackbarOpen(AUTHENTICATION_FAILED, 'warning');
      break;
    case STATUS_CODES.INTERNAL_SERVER_ERROR:
    default:
      snackbarOpen(OOPS_TRY_AGAIN, 'warning');
    }
    handleCloseWithReset();
  } else {
    if (isEditMode) {
      if (statusCategory === 'geography') {
        getStaffAugStatusData();
      } else {
        const responseDataObj = responseData?.data;
        const statusIdVal = responseDataObj?.staffingStatusId || responseDataObj?.id;
        if (statusIdVal) {
          updateRowsWithEditedStatus(statusIdVal, responseData);
        }
      }
      snackbarOpen(ADD_EDIT_STAFF_AUG_STATUS.EDIT_SUCCESS_MSG, 'success');
    } else {
      snackbarOpen(ADD_EDIT_STAFF_AUG_STATUS.ADD_SUCCESS_MSG, 'success');
      getStaffAugStatusData();
    }
    handleCloseWithReset();
  }
};

export const saveOrUpdateStatus = async ({
  payload,
  isEditMode,
  isActive,
  lastUpdatedBy,
  handleResponse,
  snackbarOpen,
  isLostDroppedStatus,
  statusCategory,
}) => {
  try {
    let requestPayload = null;
    if (statusCategory === 'geography' && isEditMode) {
      requestPayload = updateGeography({ ...payload });
    } else if (statusCategory === 'geography') {
      requestPayload = addGeography({ ...payload });
    } else if (isEditMode && isLostDroppedStatus) {
      requestPayload = editLostDroppedStatus({ ...payload, isActive, lastUpdatedBy });
    } else if (isEditMode) {
      requestPayload = editStaffingStatus({ ...payload, isActive, lastUpdatedBy });
    } else if (isLostDroppedStatus) {
      requestPayload = addLostDroppedStatus({ ...payload, lastUpdatedBy });
    } else {
      requestPayload = addStaffingStatus({ ...payload, lastUpdatedBy });
    }

    const response = await UseAxios(requestPayload);

    handleResponse(response);
  } catch (error) {
    snackbarOpen(OOPS_TRY_AGAIN, 'warning');
  }
};
